import { createGlobalStyle } from "styled-components";
import { getTheme } from "@bracket/ui/themes";

export const GlobalStyle = createGlobalStyle`
  *, *::before, &::after {
    box-sizing: border-box;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }

  html {
    display: block;
    height: 100%;
    margin: 0 auto;
    padding: 0;
    font-size: 16px;
  }

  body {
  }

  p, h1, h2, h3, h4, h5, h6, body {
    margin: 0;
  }
`;
